import React from 'react';

export const NetworkStewardContext = React.createContext(null);

export default NetworkStewardContext;
